import React from "react";
import InventarioReporte from "./InventarioReporte";
export default function ListaEstanques() { return <InventarioReporte kind="estanques" />; }
